<template>
    <div id="contracts" class="content">
      <div class="section-title">
        <div class="row">
          <div class="col-md-7">
            <h3>{{ title }}</h3>
          </div>
          <div class="col-md-5">
            <div class="userLog_bread">
              <span v-if="userLogged">
                {{
                  userLogged.comercialName
                    ? userLogged.comercialName
                    : userLogged.name + " " + userLogged.lastName
                }}
              </span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div class="filters">
            <div class="box-buscador-contratos clearfix">
                <div class="buscador-cab">Busca por:</div>
                <el-form
                    :model="contracts"
                    name="contractsForm"
                    status-icon
                    ref="contractsForm"
                >
                    <div class="row col-md-12 col-lg-12 col-xs-12 row-space" id="filtro_1">
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback">
                          <el-input
                            id="contractsInput"
                            v-model="cups"
                            autocomplete="off"
                            @focus="sessionExpired"
                            placeholder="CUPS"
                            @change="
                            params = { ...params, cups: $event};"
                          ></el-input>
                      </div>
                      <div class="form-group col-xs-12 col-md-3 col-lg-3 has-feedback">
                        <date-picker input-class ="my-picker-class" v-model="time1" type="date" valueType="format" range placeholder="Desde ~ Hasta"
                        @change="
                            params = { ...params, fecha: $event};"
                            ></date-picker>
                      </div>
                    </div>
                    <div class="row col-md-12 row-space" id="filtro_2">
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback">
                        <el-select
                          v-model="search2"
                          clearable
                          placeholder="Seleccionar más filtros"
                          @change="
                            params = { ...params, filterType: $event, filterNumber: 2 };
                            changeFilter();
                          "
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            v-bind:value="item.value"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divNameContrato_2" v-show="filter2 == 'fullName'">
                          <el-input
                          id="contractsInput"
                          v-model="name2"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Nombre y apellidos"
                          @change="
                          params = { ...params, name: $event};"
                        ></el-input>

                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divProductContrato_2 " v-show="filter2 == 'product'">
                          <el-select
                          v-model="products2"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                          @change="params = { ...params, product: $event};"
                        >
                          <el-option
                            v-for="item in products"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divAddressContrato_2" v-show="filter2 == 'address'">
                        <el-input
                          id="contractsInput"
                          v-model="address2"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Dirección"
                          @change="
                          params = { ...params, address: $event};"
                        ></el-input>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divStateContrato_2" v-show="filter2 == 'state'">
                          <el-select
                          v-model="states2"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                          @change="params = { ...params, state: $event};"
                        >
                          <el-option
                            v-for="item in states"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divEmailContrato_2" v-show="filter2 == 'email'">
                        <el-input
                          id="contractsInput"
                          v-model="email2"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Email"
                          @change="
                          params = { ...params, email: $event};"
                        ></el-input>
                      </div>
                    </div>
                    
                    <div class="row col-md-12 row-space" id="filtro_3" style="display: none" v-show="filtro3 == 'filtro3'">
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback">
                        <el-select
                          v-model="search3"
                          clearable
                          placeholder="Seleccionar más filtros"
                          @change="
                            params = { ...params, filterType: $event, filterNumber: 3};
                            changeFilter();
                          "
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            v-bind:value="item.value"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divNameContrato_3" v-show="filter3 == 'fullName'">
                          <el-input
                          id="contractsInput"
                          v-model="name3"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Nombre y apellidos"
                          @change="
                          params = { ...params, name: $event};"
                        ></el-input>

                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divProductContrato_3 " v-show="filter3 == 'product'">
                          <el-select
                          v-model="products3"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in products"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            @change="params = { ...params, product: $event};"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divAddressContrato_3" v-show="filter3 == 'address'">
                        <el-input
                          id="contractsInput"
                          v-model="address3"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Dirección"
                          @change="
                          params = { ...params, address: $event};"
                        ></el-input>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divStateContrato_3" v-show="filter3 == 'state'">
                          <el-select
                          v-model="states3"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                          @change="params = { ...params, state: $event};"
                        >
                          <el-option
                            v-for="item in states"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divEmailContrato_2" v-show="filter2 == 'email'">
                        <el-input
                          id="contractsInput"
                          v-model="email3"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Email"
                          @change="
                          params = { ...params, email: $event};"
                        ></el-input>
                      </div>
                    </div>

                    <div class="row col-md-12 row-space" id="filtro_4" style="display: none" v-show="filtro4 == 'filtro4'">
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback">
                        <el-select
                          v-model="search4"
                          clearable
                          placeholder="Seleccionar más filtros"
                          @change="
                            params = { ...params, filterType: $event, filterNumber: 4};
                            changeFilter();
                          "
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            v-bind:value="item.value"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divNameContrato_4" v-show="filter4 == 'fullName'">
                          <el-input
                          id="contractsInput"
                          v-model="name4"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Nombre y apellidos"
                          @change="
                          params = { ...params, name: $event};"
                        ></el-input>

                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divProductContrato_4 " v-show="filter4 == 'product'">
                          <el-select
                          v-model="products4"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in products"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            @change="params = { ...params, product: $event};"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divAddressContrato_4" v-show="filter4 == 'address'">
                        <el-input
                          id="contractsInput"
                          v-model="address4"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Dirección"
                          @change="
                          params = { ...params, address: $event};"
                        ></el-input>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divStateContrato_4" v-show="filter4 == 'state'">
                          <el-select
                          v-model="states4"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                          @change="params = { ...params, state: $event};"
                        >
                          <el-option
                            v-for="item in states"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divEmailContrato_4" v-show="filter4 == 'email'">
                        <el-input
                          id="contractsInput"
                          v-model="email4"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Email"
                          @change="
                          params = { ...params, email: $event};"
                        ></el-input>
                      </div>
                    </div>

                    <div class="row col-md-12 row-space" id="filtro_5" style="display: none" v-show="filtro5 == 'filtro5'">
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback">
                        <el-select
                          v-model="search5"
                          clearable
                          placeholder="Seleccionar más filtros"
                          @change="
                            params = { ...params, filterType: $event, filterNumber: 5};
                            changeFilter();
                          "
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            v-bind:value="item.value"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divNameContrato_5" v-show="filter5 == 'fullName'">
                          <el-input
                          id="contractsInput"
                          v-model="name5"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Nombre y apellidos"
                          @change="
                          params = { ...params, name: $event};"
                        ></el-input>

                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divProductContrato_5 " v-show="filter5 == 'product'">
                          <el-select
                          v-model="products5"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in products"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            @change="params = { ...params, product: $event};"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divAddressContrato_5" v-show="filter5 == 'address'">
                        <el-input
                          id="contractsInput"
                          v-model="address5"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Dirección"
                          @change="
                          params = { ...params, address: $event};"
                        ></el-input>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divStateContrato_5" v-show="filter5 == 'state'">
                          <el-select
                          v-model="states5"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                          @change="params = { ...params, state: $event};"
                        >
                          <el-option
                            v-for="item in states"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divEmailContrato_5" v-show="filter5 == 'email'">
                        <el-input
                          id="contractsInput"
                          v-model="email5"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Email"
                          @change="
                          params = { ...params, email: $event};"
                        ></el-input>
                      </div>
                    </div>

                    <div class="row col-md-12 row-space" id="filtro_6" style="display: none" v-show="filtro6 == 'filtro6'">
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback">
                        <el-select
                          v-model="search6"
                          clearable
                          placeholder="Seleccionar más filtros"
                          @change="
                            params = { ...params, filterType: $event, filterNumber: 6};
                            changeFilter();
                          "
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            v-bind:value="item.value"
                            :disabled="item.disabled"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divNameContrato_6" v-show="filter6 == 'fullName'">
                          <el-input
                          id="contractsInput"
                          v-model="name6"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Nombre y apellidos"
                          @change="
                          params = { ...params, name: $event};"
                        ></el-input>

                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divProductContrato_6 " v-show="filter6 == 'product'">
                          <el-select
                          v-model="products6"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                        >
                          <el-option
                            v-for="item in products"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            @change="params = { ...params, product: $event};"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divAddressContrato_6" v-show="filter6 == 'address'">
                        <el-input
                          id="contractsInput"
                          v-model="address6"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Dirección"
                          @change="
                          params = { ...params, address: $event};"
                        ></el-input>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divStateContrato_6" v-show="filter6 == 'state'">
                          <el-select
                          v-model="states6"
                          clearable
                          class="selectFiltro"
                          id="selectFiltro"
                          @change="params = { ...params, state: $event};"
                        >
                          <el-option
                            v-for="item in states"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="form-group col-xs-12 col-md-6 col-lg-6 has-feedback" style="display: none" id="divEmailContrato_6" v-show="filter6 == 'email'">
                        <el-input
                          id="contractsInput"
                          v-model="email6"
                          autocomplete="off"
                          @focus="sessionExpired"
                          placeholder="Email"
                          @change="
                          params = { ...params, email: $event};"
                        ></el-input>
                      </div>
                    </div>

                </el-form>
                <div class="row col-xs-12 col-md-12 col-lg-12 row-space" style="height:30px;margin-bottom:50px" >
                    <div class="col-xs-12 col-md-6 col-lg-6 has-feedback" style="text-align:left">
                        <button type="submit" class="btn_addFilter" @click="addFilter()" >Añadir filtro</button>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-6 has-feedback" style="text-align:right; margin-bottom: 20px">
                        <button type="submit" class="btn_filtrado filtradoBuscar" @click="getContracts()" >Buscar</button>
                        <!-- <button type="submit" class="btn_filtrado filtradoBuscar" id="showContracts" name="showContracts" >Buscar</button> -->
                        <button type="reset" class="btn_filtrado filtradoLimpiar" @click="cleanFilters()">Limpiar</button>
                    </div>
                </div>
            </div>
      </div>
      <div class="block" style="border:1px solid #e6e6e6">
        <el-table 
          :data="contracts"  
          border 
          style="width: 100%; text-align:center;" 
          header-cell-class-name="my-header" >
          <el-table-column label="" width="auto" min-width="5" class="contractColumn">
            <template slot-scope="scope">
                <div class="row">
                    <button style="top: 36px;left: auto;right: 3px;height: 15px;width: 49px;margin-top: 0;color: white;border: 0.15em solid white;
                    border-radius: 1em;box-shadow: none;box-sizing: content-box;text-align: center;text-indent: 0 !important;font-family: inherit;line-height: 1em;font-size: 13px;background-color: #ff0558;"
                    @click="
                      selectedContract = scope.row;
                      showModal = true;
                    ">
                      + info
                    </button>
                </div>
              </template>
          </el-table-column>
          <el-table-column
            class="contractColumn"
            label="ESTADO"
            width="auto"
            min-width="8"
          >


          <template slot-scope="scope">
              <div
                class="d-inline-flex justify-content-around"
                style="width: 100%"
                v-html= printState(scope)
              >
              </div>
            </template>
          </el-table-column>
          <el-table-column
          class="contractColumn"
            label="CUPS"
            width="auto"
            min-width="10"
          >
          <template slot-scope="scope">
              <span class="cell">{{
                scope.row.Pv2_CustomServicePoint__r ? scope.row.Pv2_CustomServicePoint__r.GEO_CUPS20__c : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Pv2_LocationAddress__c"
            label="DIRECCIÓN"
            width="auto"
            class="contractColumn"
            sortable
            min-width="20"
          >
          </el-table-column>
          <el-table-column
            prop="Account.Name"
            label="NOMBRE Y APELLIDOS"
            width="auto"
            class="contractColumn"
            sortable
            min-width="15"
            v-if="shouldShowCols"
          >
          </el-table-column>
          <el-table-column
            prop="Contact.Email"
            label="EMAIL"
            width="auto"
            class="contractColumn"
            sortable
            min-width="11"
            v-if="shouldShowCols"
          >
          </el-table-column>
          <el-table-column
            prop="Contact.Phone"
            label="TELÉFONO"
            width="auto"
            class="contractColumn"
            sortable
            min-width="8"
            v-if="shouldShowCols"
          >
          </el-table-column>
          <el-table-column
            prop="Pv2_FechaVenta__c"
            label="FECHA"
            width="auto"
            class="contractColumn"
            sortable
            min-width="8"
            v-if="shouldShowCols"
          >
          </el-table-column>
          <el-table-column
            prop="Product2.Pv2_NombreAPIPrecio__c"
            label="PRODUCTO"
            width="auto"
            class="contractColumn"
            sortable
            min-width="8"
            v-if="shouldShowCols"
          >
          </el-table-column>
        </el-table>
        <div class="row pag">
          <div class="col-md-4 item arrows">
            <div class="d-flex align-items-center pointer" v-if="page > 1">
              <div
                @click="
                  page = page > 2 ? page - 1 : 1;
                  getContracts();
                "
              >
                <i class="el-icon-arrow-left"></i>
                <span>ANTERIOR</span>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12 item">
            <el-pagination
              class="text-center"
              @size-change="getContracts()"
              @current-change="getContracts()"
              :current-page.sync="page"
              :page-size="pageSize"
              layout=" prev, pager, next"
              :total="totalContracts"
            >
            </el-pagination>
          </div>
          <div class="col-md-4 item arrows">
            <div
              class="d-flex justify-content-end align-items-center pointer"
              v-if="totalPage > 1 && page != totalPage"
            >
              <div
                @click="
                  page = totalPage > page ? page + 1 : page;
                  getContracts();
                "
              >
                <span>SIGUIENTE</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <br />
        <span class="secondary">
          MOSTRANDO {{ page }} - {{ totalPage }} de {{ totalContracts }} RESULTADOS
        </span>
      </div>
      <Modal
        v-if="showModal"
        :size="'medium'"
        :theme="'white'"
        :customHeight=true
        @close="
          showModal = false;
          titleModal = '';"
      >
        <template v-slot:content>
          <table  
            style="border-collapse: collapse"
            border="1"
            width="100%"
            cellspacing="0"
            cellpadding="0">
            <tr>
              <td>ID agente:</td>
              <td>{{ selectedContract.Pv2_IdAgente__c }}</td>
            </tr>
            <tr>
              <td>Estado:</td>
              <td>{{ selectedContract.Pv2_Status__c }}</td>
            </tr>
            <tr>
              <td>CUPS:</td>
              <td>{{ selectedContract.Pv2_CustomServicePoint__r.GEO_CUPS20__c }}</td>
            </tr>
            <tr>
              <td>Dirección:</td>
              <td>{{ selectedContract.Pv2_LocationAddress__c }}</td>
            </tr>
            <tr>
              <td>Nombre y apellidos:</td>
              <td>{{ selectedContract.Account.Name }}</td>
            </tr>
            <tr>
              <td>Email:</td>
              <td>{{ selectedContract.Contact.Email }}</td>
            </tr>
            <tr>
              <td>Teléfono:</td>
              <td>{{ selectedContract.Contact.Phone }}</td>
            </tr>
            <tr>
              <td>Fecha:</td>
              <td>{{ selectedContract.Pv2_FechaVenta__c }}</td>
            </tr>
            <tr>
              <td>Producto:</td>
              <td>{{ selectedContract.Product2.Pv2_NombreAPIPrecio__c }}</td>
            </tr>
            <tr>
              <td>Cupón:</td>
              <td>{{ selectedContract.Pv2_Cupon__c }}</td>
            </tr>
            <tr>
              <td>Fecha de cancelación:</td>
              <td>{{ selectedContract.Pv2_FechaCancelacion__c }}</td>
            </tr>
            <tr>
              <td>Fecha de baja:</td>
              <td>{{ selectedContract.Pv2_FechaBajaCont__c }}</td>
            </tr>
            <tr>
              <td>Motivo de cancelación:</td>
              <td>{{ selectedContract.Pv2_MotivoCancelacion__c }}</td>
            </tr>
            <tr>
              <td>Motivo de baja:</td>
              <td>{{ selectedContract.Pv2_MotivoBajaContrato__c }}</td>
            </tr>
            <tr>
              <td>Deuda:</td>
              <td>{{ selectedContract.Pv2_DeudaDeContrato__c }}</td>
            </tr>
            <tr>
              <td>Comentarios canal de venta:</td>
              <td>{{ selectedContract.Pv2_ComentariosCanalDeVenta__c }}</td>
            </tr>
            <tr>
              <td>Comentarios Podo:</td>
              <td>{{ selectedContract.Pv2_ComentariosPodo__c }}</td>
            </tr>
            <tr>
              <td>Origen:</td>
              <td>{{ selectedContract.Pv2_OrigenDelPedido__c }}</td>
            </tr>
          </table>
          <!-- <div class="row">
            <div class="col-md-4">
              <span>ID agente:</span>
            </div>
            <div class="col-md-8">
              <span>{{ selectedContract.Account.Name }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <span>Estado:</span>
            </div>
            <div class="col-md-8">
              <span>{{ selectedContract.Account.Name }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <span>CUPS:</span>
            </div>
            <div class="col-md-8">
              <span>{{ selectedContract.Account.Name }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <span>Dirección:</span>
            </div>
            <div class="col-md-8">
              <span>{{ selectedContract.Account.Name }}</span>
            </div>
          </div> -->
          <!-- <div class="text-center" id="text">
            <label>
     
              <span>{{ selectedContract.Account.Name }}</span>
            </label>
            <button
              class="btn"
              style="margin: 40px 0px"
              @click="
                showModal = false;
                deleteUser(selectedUser.id);
              "
            >
              Aceptar
            </button>
          </div> -->
        </template>
      </Modal>
    </div>
  </template>
  
  <script>
  // Components
  import { mapState } from "vuex";
  import Modal from "@/components/Modal";
  
  import AuthService from "@/services/auth.service";
  import UserService from "@/services/user.service";
  import Pagination from "@/model/Pagination";
  import contractService from '@/services/contract.service';
  import DatePicker from 'vue2-datepicker';

  import { Loading } from "element-ui";

  import 'vue2-datepicker/index.css';

  
  export default {
    name: "contracts",
    components: { Modal, DatePicker },
    data() {
      return {
        modalHeight: 800,
        numFilter : 2,
        time1: null,
        title: "GESTIÓN DE CONTRATOS",
        showModal: false,
        contracts: null,
        totalContracts: 0,
        page: 1,
        pageSize: 50,
        totalPage: 0,
        search: "",
        search2: "",
        search3: "",
        search4: "",
        search5: "",
        search6: "",
        products2: "",
        products3: "",
        products4: "",
        products5: "",
        products6: "",
        address2: "",
        address3: "",
        address4: "",
        address5: "",
        address6: "",
        name2: "",
        name3: "",
        name4: "",
        name5: "",
        name6: "",
        email2: "",
        email3: "",
        email4: "",
        email5: "",
        email6: "",
        states1: "",
        states2: "",
        states3: "",
        states4: "",
        states5: "",
        states6: "",
        searchContract: "",
        types: [
          { label: "Nombre y apellido", value: "fullName", disabled: false },
          { label: "Producto", value: "product", disabled: false },
          { label: "Dirección", value: "address", disabled: false },
          { label: "Estado", value: "state", disabled: false },
          { label: "Email", value: "email", disabled: false },
        ],
        products: [
          {label: "FLEXI UNO", value: "FLEXI UNO"},
          {label: "FLEXI DOS", value: "FLEXI DOS"},
          {label: "FLEXI TRES", value: "FLEXI TRES"},
          {label: "FLEXI UNO PRECIO DE COSTE", value: "FLEXI UNO PC"},
          {label: "FIJO", value: "FIJO"},
          {label: "FLEXI TRES AUTOCONSUMO", value: "FLEXI TRES AUTOCONSUMO"},
          {label: "ÓPTIMA", value: "ÓPTIMA"},
        ],
        states: [
        {label: "Activado", value: "Activated"},
        {label: "Alta", value: "Draft"},
        {label: "Baja contrato", value: "Baja contrato"},
        {label: "Cancelado", value: "Cancelled"},
        {label: "Pendiente activación", value: "Activo pending"},
        {label: "Pendiente Anulación", value: "Pendiente Anulación"},
        {label: "Pendiente electricidad", value: "Pendiente electricidad"},
        {label: "Pendiente gestión canal", value: "Pendiente gestión canal"},
        {label: "Pendiente gestión interna", value: "Pendiente gestión interna"},
        {label: "Pendiente validación", value: "Pending Validation"},
        {label: "Reabierto", value: "Reopen"},
        {label: "Suspendido", value: "Suspendido"},
        ],

        cups: "",
        desde: "",
        hasta: "",
        filter1: "",
        filter2: "",
        filter3: "",
        filter4: "",
        filter5: "",
        filter6: "",
        filtro1:"",
        filtro2:"",
        filtro3:"",
        filtro4:"",
        filtro5:"",
        filtro6:"",
        search1: null,
        // Active: true, false, or not present
        params: {
        },
        selectedContract: {}
      };
    },
    mounted() {
      this.sessionExpired();
      document.querySelector("#app").scrollTop = 0;
      // this.getContracts();
    },
    computed: {
      ...mapState({
        userLogged: "user"
      }),
      shouldShowCols() {
        console.log("SHOULDSHOWCOLS -> " + window.innerWidth);
        if(window.innerWidth > 1280){
          return true;
        }else{
          return false;
        }
      },
    },
    methods: {
      sessionExpired() {
        AuthService.sessionExpired();
      },
    getContracts(){
      const loadingInstance = Loading.service({ fullscreen: true });
      this.contracts = [];
        contractService.findAll(
          new Pagination(this.page - 1, this.pageSize, null),
          this.params
        )
          .then(response => {
            loadingInstance.close();
            this.contracts = response.data.data.records;
            this.totalContracts = response.data.data.recordsTotal;
            this.totalPage = Math.floor(response.data.data.recordsFiltered/this.pageSize)+1 ;
          })
          .catch();
      },
      printState(state){

        const status_txt = [];

        status_txt['Activated']='Activado';
        status_txt['Draft']='Alta';
        status_txt['Baja contrato']='Baja contrato';
        status_txt['Cancelled']='Cancelado';
        status_txt['Activo pending']='Pendiente activación';
        status_txt['Pendiente Anulación']='Pendiente Anulación';
        status_txt['Pendiente electricidad']='Pendiente electricidad';
        status_txt['Pendiente gestión canal']='Pendiente gestión canal';
        status_txt['Pendiente gestión interna']='Pendiente gestión interna';
        status_txt['Pending Validation']='Pendiente validación';
        status_txt['Reopen']='Reabierto';
        status_txt['Suspendido']='Suspendido';


        if(state.row.Pv2_Status__c === "Activated"){
            return "<div class='status-actived'>"+status_txt[state.row.Pv2_Status__c]+"</div>";
        }else if(state.row.Pv2_Status__c === "Cancelled" || state.row.Pv2_Status__c === "Baja contrato" || state.row.Pv2_Status__c === "Suspendido"){
            return "<div class='status-cancelled'>"+status_txt[state.row.Pv2_Status__c]+"</div>";
        }else{
            return "<div class='status-register'>"+status_txt[state.row.Pv2_Status__c]+"</div>";
        }
      },
      changeFilter() {
        switch(this.params.filterType){
          case "fullName":
          this.types[0].disabled = true;
          break;
          case "product":
          this.types[1].disabled = true;
          break;
          case "address":
          this.types[2].disabled = true;
          break;
            case "state":
            this.types[3].disabled = true;
            break;
            case "email":
            this.types[4].disabled = true;
            break;
        }        

        switch(this.params.filterNumber){

          case 1:
              this.filter1 = this.params.filterType;
            break;
          case 2:
          this.filter2 = this.params.filterType;
            break;
          case 3:
          this.filter3 = this.params.filterType;
            break;
          case 4:
          this.filter4 = this.params.filterType;
            break;
          case 5:
          this.filter5 = this.params.filterType;
            break;
          case 6:
          this.filter6 = this.params.filterType;
            break;
        };
        
    },
    addFilter(){
      //compruebo qué filtros tengo visibles y añado el siguiente
      this.numFilter+=1;

      if(this.filtro3 == ""){
        //No estoy mostrando el filtro3, por lo que lo muestro
        this.filtro3 = "filtro3";
      }
      else if(this.filtro3 == "filtro3" && this.filtro4 == ""){
        //el filtro3 está visible y el 4 no, por lo que muestro el filtro4
        this.filtro4 = "filtro4";
      }

      else if(this.filtro4 == "filtro4" && this.filtro5 == ""){
        //el filtro3 está visible y el 4 no, por lo que muestro el filtro4
        this.filtro5 = "filtro5";
      }

      else if(this.filtro5 == "filtro5" && this.filtro6 == ""){
        //el filtro3 está visible y el 4 no, por lo que muestro el filtro4
        this.filtro6 = "filtro6";
      }

      // if($('#filtro_3').is(':visible') && $('#filtro_4').is(':hidden')){
      //       valor_filtros.forEach(function (filtro, index) {
      //           $('#filtroContrato_4').append('<option value="' + filtro.value + '">' + filtro.name + '</option>');
      //       });
      //       $('#filtro_4').show();
    },
    cleanFilters(){
      location.reload();
    },
      getUserById(path) {
        this.sessionExpired();
        this.$router.push("/new-user/" + path);
      },
      getGeneratePassword() {
        this.sessionExpired();
        this.$router.push("/admin-password/");
      },
      deleteUser(id) {
        UserService.deleteUser(id)
          .then(() => {
            this.getContracts();
          })
          .catch(() => {
            this.$notify({
              title: "Error",
              message: "Error eliminando usuario",
              type: "error",
              duration: 3000
            });
          });
      }
    }
  };

  </script>
  <style lang="scss">
  @import "src/assets/sass/styles";
  #contracts {
    width: 100%;
    height: auto;
    .iframe-div-container {
      height: 91%;
    }

    .iframe-modal-element {
      height: 100%;
      width: 100%;
    }
    .modal-container{
      height: auto !important;
    }
    .my-header{
      background: #dbdbdb !important;
          padding:12px 12px !important;
          font-weight: bold !important;
          margin-bottom: 25px !important;
          color: #333!important;
    }

    .modal-dialog .modal-content {
          /* 80% of window height */
          height: 100%;
      }

    .modal-body {
        /* 100% = dialog height, 120px = header + footer */
        overflow-y: visible;
    }

    .buscador-cab{
          background: #dbdbdb;
          padding:12px 12px;
          font-weight: bold;
          margin-bottom: 25px;
          color: #333!important;
      }

      .status-actived::before{
        content: '';
        background: #cff892;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        position: absolute;
        top: 10;
        left: 0;
    }

   .status-register::before{
      content: '';
      background: #04d8fe;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      position: absolute;
      top: 10;
      left: 0;
  }

   .status-cancelled::before{
      content: '';
      background: #fe0002;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      position: absolute;
      top: 10;
      left: 0;
  }

    .filters {
      .my-picker-class{
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        border-bottom: 1px solid #ff0558 !important;
        height: 50px !important;
        color: black !important;
        font-weight: 600;
        width: 100% !important;
        font-size: 18px !important;
      }

      .el-select {
        width: 100%;
      }
      .box-buscador-contratos{
        background: #FFFFFF;
        border: 1px solid #e6e6e6;
      }
      .contractsInput {
        border-top: 0 !important;
        border-left: 0 !important;
        border-right: 0 !important;
        border-radius: 0 !important;
        border-bottom: 1px solid #ff0558 !important;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
      }
      #contractsInput {
        border-top: 0 !important;
        border-left: 0 !important;
        border-right: 0 !important;
        border-radius: 0 !important;
        border-bottom: 1px solid #ff0558 !important;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
      }
      .contractsInput ::placeholder {
        color: #ff0558!important;
        font-weight: 500;
      }

      .buscador-cab{
          background: #dbdbdb;
          padding:12px 12px;
          font-weight: bold;
          margin-bottom: 25px;
          color: #333!important;
      }

      .btn_addFilter{
        width: 130px;
        border-radius:5px !important;
        height: 40px !important;
        background-color: transparent !important;
        border-color: gray !important;
        background: transparent !important;
        color:gray !important;
        border-width: 1px !important;
      }

      .btn_filtrado {
        width: 110px;
        border-radius:5px !important;
        height: 40px !important;

      }

      .filtradoBuscar{
          background: #ff0558 !important;
          border-width: 0px;
          color:white !important;
          margin-right: 5px !important;
      }

      .filtradoLimpiar {
          background-color: transparent !important;
          border-color: #afafaf !important;
          background: transparent !important;
          color:#afafaf !important;
          border-width: 1px !important;
      }

      #selectFiltro{
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid #ff0558 !important;
      }

    }
    
      .contractColumn{
        font-size: 15px !important;
      border: 1px solid pink !important;
      height: 45px;
      vertical-align: middle;
      }

      .el-table tr {
        font-size: 15px;
        border: 1px solid #ddd !important;
        height: 45px;
        vertical-align: middle;
      }

      .el-table .cell{
        font-size: 14px !important;
      }

    .el-table {
      font-size: 15px !important;
      .el-table__header {
        th {
          background: $grey-white-color;
        }
      }
      td {
        padding: 25px 0px;
      }
      .cell {
        color: black;
        font-weight: 600;
      }
      img {
        width: 25px;
      }
    }
    .pag {
      margin: 0px;
      div.item {
        padding: 15px 0px;
        border-top: 1px solid $grey-dark-color;
        border-bottom: 1px solid $grey-dark-color;
        overflow: hidden;
        div {
          height: 100%;
          i {
            color: $grey-dark-color;
            font-size: 24px;
            font-weight: 600;
          }
          span {
            padding: 0px 10px;
          }
          .btn-prev,
          .btn-next {
            display: none;
          }
        }
      }
    }
  }
  
  @media (max-width: 992px) {
    #user {
      .el-table {
        font-size: 20px;
      }
      .filters {
        .btn {
          margin-top: 20px !important;
        }
      }
    }
  }
  
  @media (max-width: 800px) {
    #user {
      .btn_secondary {
        width: 100% !important;
      }
    }
  }
  
  @media (max-width: 767px) {
    #user {
      .pag {
        div.item {
          &.arrows {
            display: none;
          }
          button {
            i {
              display: inline !important;
            }
          }
          .btn-prev,
          .btn-next {
            display: inline !important;
            color: $grey-dark-color !important;
          }
        }
      }
    }
  }
  </style>
  